export default __webpack_public_path__ + "static/hanseatic-bank-32bda4406ef1e7df3196378ca1b8580d.svg";